export default "__VITE_ASSET__BcCrgIaB__"